import request from './request';

const WATCH_DELAY = 5000;
const MAX_ATTEMPTS = 5;

export default function(job_id) {
  return new Promise((resolve, reject) => {
    setTimeout(watchDelajedJob, WATCH_DELAY, job_id, resolve, reject);
  });
}


function watchDelajedJob(job_id, resolve, reject) {
  let url = '/admin/delayed_jobs/' + job_id;
  request('GET', url).then(job => {
    if (job.running === false) {
      resolve();
    } else if (job.attempts === MAX_ATTEMPTS) {
      reject(job.last_error);
    } else {
      setTimeout(watchDelajedJob, WATCH_DELAY, job_id, resolve, reject);
    }
  }).catch(e => {
    setTimeout(watchDelajedJob, WATCH_DELAY, job_id, resolve, reject);
  });
}
